import * as React from "react";
import Style from "../../_data/models/Style";
import MyProfileSpecialsComponent from "./MyProfileSpecialsComponent";
import Special from "../../_data/models/Special";
import Meta from "../../_data/models/Meta";
import {OrderedMap} from "immutable";
import MyProfileStylesComponent from "./MyProfileStylesComponent";
import LoadingIndicatorComponent from "../../_widgets/loadingIndicator/LoadingIndicatorComponent";

interface result {
    items:any;
    meta:Meta;
}

interface resultWithLoad extends result{
    loading:boolean;
}

interface Props {
    loadingTab: boolean;
    styles: result;
    specials: resultWithLoad;
    styleLoad: boolean;
    likedStyleLoad: boolean;
    loadMore: (meta: Meta, resource: string, isLiked?: boolean) => void;
}

const MyProfileTabViewComponent = (props: Props) => {
    const {styleLoad, likedStyleLoad} = props;

    return (
        <div className="tabs-content" data-tabs-content="users">
            <div className="tabs-panel is-active">
                {(styleLoad || likedStyleLoad) && <MyProfileStylesComponent {...props}/>}
                {!(styleLoad || likedStyleLoad) && <MyProfileSpecialsComponent {...props}/>}
            </div>
        </div>
    );
};

export default MyProfileTabViewComponent;


// WEBPACK FOOTER //
// ./app/client/user/components/MyProfileTabViewComponent.tsx